import { Link as LinkComponent } from 'react-router-dom';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 7px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 36px;
  background: var(--v3-black-2);
`;

export const WalletInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
`;

export const Link = styled(LinkComponent)`
  text-decoration: none;
  color: var(--v3-text-color-secondary);
  &:hover {
    color: var(--v3-primary-color);
  }
`;

export const Balance = styled.div`
  align-self: stretch;
  color: var(--v3-primary-color);
  opacity: 0.8;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const Username = styled.div`
  align-self: stretch;
  color: var(--v3-text-color);
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.15px;
`;
